'use client';

import React, { useState, useEffect } from 'react';
import { useAppointmentModalStore, AppointmentModalState } from '@/store/useAppointmentModalStore';

interface AppointmentButtonProps {
  className?: string;
  children?: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline' | 'light';
  size?: 'sm' | 'md' | 'lg';
  initialData?: {
    name?: string;
    email?: string;
    phone?: string;
    datetime?: string;
    comments?: string;
  };
}

const AppointmentButton: React.FC<AppointmentButtonProps> = ({
  className = '',
  children = 'Prendre Rendez-vous',
  variant = 'primary',
  size = 'md',
  initialData = null,
}) => {
  // Vérification du rendu côté client pour éviter les erreurs d'hydratation
  const [isMounted, setIsMounted] = useState(false);
  const openModal = useAppointmentModalStore((state: AppointmentModalState) => state.open);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  // Définition des styles en fonction des variants
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 rounded-full cursor-pointer';
  
  const variantStyles = {
    primary: 'bg-primary text-white hover:bg-primary-600',
    secondary: 'bg-secondary text-primary hover:bg-secondary/90',
    outline: 'border border-primary text-primary hover:bg-primary hover:text-white',
    light: 'bg-white text-primary hover:bg-cream',
  };
  
  const sizeStyles = {
    sm: 'text-sm px-4 py-2',
    md: 'px-6 py-3',
    lg: 'text-lg px-8 py-4',
  };
  
  const buttonStyles = `${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className}`;


  const handleClick = () => {
    console.log("AppointmentButton - Click détecté");
    openModal(initialData);
  };
  
  // Utilisation d'un bouton non fonctionnel pour le premier rendu statique
  // puis remplacement par le bouton fonctionnel après hydratation
  if (!isMounted) {
    return (
      <button
        className={buttonStyles}
        disabled
      >
        {children}
      </button>
    );
  }

  return (
    <button
      onClick={handleClick}
      className={buttonStyles}
    >
      {children}
    </button>
  );
};

export default AppointmentButton;